// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2rbsX","log":"ModalInventoryLogs_log__3R18q","date":"ModalInventoryLogs_date__3bTNT","userName":"ModalInventoryLogs_userName__3J5J0"};